import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib/helpers/api';
import PartnerService from '@iso/services/SettingsService/PartnerService';
import { types, actions } from './reducer';

function* deletePartner({ id }) {
    try {
        yield call(PartnerService.deleteOne, id);
        yield put(actions.deletePartnerSucceeded(id));
    } catch (error) {
        yield put(actions.deletePartnerFailed(extractError(error)));
    }
}

function* watchDeletePartner() {
    yield takeEvery(
        types.REQUEST_DELETE_PARTNER,
        deletePartner,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeletePartner),
    ]);
}

export default deleteSaga;
